const primary = {
  50: "#e3e5ff",
  100: "#b2b5ff",
  200: "#7f84ff",
  300: "#4c54ff",
  400: "#1a22ff",
  500: "#0009e6",
  600: "#0006b4",
  700: "#000482",
  800: "#000250",
  900: "#000021",
};

export default primary;
